






import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
    mounted(): void {
        if (!localStorage.getItem('lang')) {
            this.$i18n.locale = navigator.language.split('-')[0].toString();
        }
    }
}
